export default __webpack_public_path__ + "static/banl-logo-reverse-209ccfd40b8e1555fae7af7ee6f34aa0.png";